var onLoadIsotopeHeight = 0;
var isIsotopeFlag = 0;
define('ajaxComponent',[
  'jquery',
  'features/favorites',
  'lib/animations/offers.animations',
  'responsive',
  'zipTools',
  'lib/util/zip',
  'components/offers/offers-ajax-filtered',

  // side effect includes
  'bat',
  'Handlebars'
], function (
  $,
  favorites,
  offersAnimations,
  responsive,
  zipTools,
  zip,
  offerAjaxFiltered
) {
  // AjaxOffers and AjaxInventory's parent class
  var AjaxComponent = function AjaxComponent(serviceUrl, useStartIndex, CACHE_IDS, $template, $isotopeContainer, useModal, includedParams) {
    this.serviceUrl = serviceUrl;
    this.baseUrl = serviceUrl;
    this.useStartIndex = useStartIndex;
    this.CACHE_IDS = CACHE_IDS;
    this.cachedIds = [];
    this.$template = $template;
    this.$isotopeContainer = $isotopeContainer;
    this.paramString = '';
    this.paramStringStartIndexes = {};
    this.cachedURLs = {};
    this.isInitialLoad = true;
    this.isLoading = false;
    this.initialMinMsrp = 0;
    this.initialMaxMsrp = 0;
    this.minMsrp = 0;
    this.maxMsrp = 0;
    this.initialTotal = 0;
    this.currentTotal = 0;
    this.cookieName = 'showMoreOffersStartIndex';

    if (includedParams) {
      this.paramString = includedParams;
    }

    if (useModal === undefined) {
      this.useModal = true;
    } else {
      this.useModal = useModal;
    }
  };

  AjaxComponent.prototype = {
    init: function () {
      this.isLoading = true;
      this.data = {
        items: []
      };
      // TODO: clean up.
      this.getData();
    },

    addEventListeners: function () {
      var self = this;

      $('#modal-try-again-button').click(function () {
        self.init();
      });

      $(window).on('ZIP_CODE_CHANGED', function () {
        if (self.$isotopeContainer && self.$isotopeContainer !== null) {
          self.$isotopeContainer.isotope('remove', self.$isotopeContainer.find('.isotope-item'));
        }
        self.isInitialLoad = true;
        self.clearCached();
        self.init();
      });
    },

    checkNoItemsFound: function () {
      var self = this;
      if (self.$isotopeContainer !== null) {
        var numShowing = self.$isotopeContainer.children('.isotope-item:not(.isotope-hidden)').length;
        // update datalayer with an offer_list_result_count of 0
        var dataToAdd = {
          offer_list_result_count: numShowing.toString()
        };
        $.extend(window.dataLayerBAT.data, dataToAdd);

        if (numShowing > 0) {
          if (self.currentTotal <= numShowing) {
            $('.total-found').html(numShowing);
            $('#showing-number-of-total .number').html($('#isotope-offers').find($('.isotope-item:not(.isotope-hidden)')).css('opacity', 1).length);
          }
          $('.js-more-row').hide();
        } else {
          if (self.paramString === '' && $('#no-vehicles-found-initial').length) {
            $('#no-vehicles-found-initial').show();
          } else {
            $('#no-offers-found').show();
          }
          $('#showing-number-of-total').hide();
          $('.js-more-row').hide();
          $('.total-found').html('0');
        }
      }
    },

    checkDisplayShowMore: function () {
      var self = this;
      $('#no-vehicles-found-initial').hide();
      $('#no-offers-found').hide();
      $('#showing-number-of-total').show();
      $('#show-more-button').show();

      if (isIsotopeFlag === 0) {
        onLoadIsotopeHeight = $('#isotope-offers').css('height');
        isIsotopeFlag = 1;
      }

      // if(self.cachedIds.length >= self.initialTotal) { $('#show-more-button').attr('disabled', true); }

      if (self.$isotopeContainer !== null) {
        var numShowing = self.$isotopeContainer.children('.isotope-item:not(.isotope-hidden)').length;
        if (self.currentTotal <= numShowing) {
          if (self.currentTotal < numShowing) {
            $('.total-found').html(numShowing);
          }
          // console.log('DISABLE SHOW MORE BUTTON');
          // $('div.show-more').hide();
          // $('.display-all').hide();
          $('.js-more-row').hide();
          $('#show-more-button').hide(); // Found on offers/seriesName/ pages
        } else {
          // $('div.show-more').show();
          // $('.display-all').show();
          $('.js-more-row').show();
        }
      }
      var selectedLabel = '';
      if (responsive() === 'sm') {
        selectedLabel = $('.tab-filter-select').children('option:selected').text();
      } else {
        selectedLabel = $('#filters-panel').find('li.active').children('a').text();
      }
      var limitOffers = $('#limit-offers').text();
      if (limitOffers == 'yes') {
        $('.js-more-row').hide();
        if (self.$isotopeContainer.children('.isotope-item:not(.isotope-hidden)').length > 9) {
          $('.isotope-item').addClass('isotope-hidden').css('opacity', 0);
          $('.isotope-item:lt(9)').removeClass('isotope-hidden').css('opacity', 1);
          $('#showing-number-of-total .number').html('9');
          $('.total-found').html('9');
          $('#isotope-offers').css('height', onLoadIsotopeHeight);
        } else {
          $('.total-found').html(self.$isotopeContainer.children('.isotope-item:not(.isotope-hidden)').length);
        }
      }
    },

    clearCached: function () {
      this.cachedIds = [];
      this.paramStringStartIndexes = {};
      this.paramString = '';
      this.cachedURLs = [];
    },

    isCached: function (id) {
      if (!this.CACHE_IDS) {
        return false;
      }
      if (this.cachedIds.indexOf(id) > -1) {
        return true;
      }
      return false;
    },

    showMore: function () {
      this.paramStringStartIndexes[this.paramString] += 9;
    },

    getData: function () {
      var self = this;
      /* BAT-595 - a side-effect of passing in the zipcode from the offers-strip component is that this code
         now tacks on a *second* zipCode parameter, which downstream breaks things because somewhere the code
         ends up getting an array of zip-codes and tries to treat it as a string and fails.
         The expedient fix is to make sure we do not add another zipCode parameter to the URL coming from this
         code to avoid that problem. */
      var zipCodeString = /^.*zipCode=[0-9]+.*$/.test(self.baseUrl) ? '' : '&zipCode=' + zip.getCookiedDefaultFallback();

      if (self.isInitialLoad && self.constructor.name === 'AjaxInventory') {
        self.paramString += '&sort=asc';
      }
      // self.paramString = '&offerType=apr&series=yaris';
      // console.log('::: baseUrl:', self.baseUrl);
      // console.log('::: paramString:', self.paramString);

      if (self.useStartIndex) {
        if (self.paramStringStartIndexes[self.paramString] === undefined) {
          self.paramStringStartIndexes[self.paramString] = 0;
        }
        self.serviceUrl = self.baseUrl // ex: /offers-service/OFFERS/allOffers?pageSize=9'
        + zipCodeString // ex: ?zipCode=01606
        + self.paramString // ex: &modelCode=camry&rows=9&loader=results
        + self.startString // ex: &start= or &startIndex=
        + (self.paramStringStartIndexes[this.paramString]).toString(); // ex: 9
      } else {
        self.serviceUrl = self.baseUrl + zipCodeString + (self.paramString).toString();
      }

      if (self.minMsrp != 0) {
        self.serviceUrl += '&minMsrp=' + self.minMsrp.toString();
      }
      if (self.maxMsrp != 0) {
        self.serviceUrl += '&maxMsrp=' + self.maxMsrp.toString();
      }

      // console.log('-------------- START AJAX --------------');

      // console.log('detecting language from URL');

      if (window.location.href.indexOf('/es') > -1) {
        // console.log('this URL contains /es ');
        // if the serviceUrl already contains lang=es, don't need to add
        if (self.serviceUrl.indexOf('lang=es') > -1) {
        // console.log('serviceUrl already contains lang=es');
        } else {
          self.serviceUrl = self.serviceUrl + '&lang=es';
        // console.log('NEW URL: ' + self.serviceUrl);
        }
      } else {
        // console.log('this URL does NOT contain /es ');
      }

      if (self.useModal) {
        var showDealersParam = location.href.indexOf('showDealers');
        var showDealersChatParam = location.href.indexOf('showDealersChat');

        if (showDealersParam == -1 || showDealersChatParam == -1) {
          // "custom" inline modal, should be used on offers pages only, but
          // it interferes with other pages where we DO want to show the loader, AND
          // when we also have an offers-service call.
          // creating inline modal for use elsewhere, instead.
          $('.modal-backdrop').css('background-color', '#f0f0f0');
        } else {
          $('.modal-backdrop').not(':first').remove();
          $('.close-ground').on('click', function (e) {
            $('#ctdealer-modal').hide();
            $('.modal-backdrop').hide();
          });
        }

        // This alters the position of our loader. Prevents it from covering the
        // entire page
        /* $('.modal-backdrop').css('position', 'absolute');
        $('#loading-modal').css('pointer-events', 'none');
        $(".modal-backdrop").appendTo("#main-wrapper-row"); */
      }
      if (self.serviceUrl.indexOf('allOffers?') >= 0) {
        offerAjaxFiltered.getOffers(self.serviceUrl)
          .then(function (data) {
            // used to reside in parseData func directly
            // TODO: move to its own jam too, outta here
            if (data.containsErrors && data.totalOffers < 1 && data.error.length) {
              self.isLoading = false;
              // These events are triggered on each instance, on purpose!
              $(self).trigger('ERROR');
              $(self).trigger('NO_ITEMS_FOUND');
              for (var i = 0; i < data.error.length; i += 1) {
                var errorItem = data.error[i];
                if (errorItem === 'Mismatch zip and tda code entered.') {
                  self.isTDAZipMisMatchError = true;
                }
              }

              // BAT25-329 In case of multiple offer calls, ensure we only prompt once
              // This should no longer be the case but until that can be tested...
              if (self.isTDAZipMisMatchError && !AjaxComponent.misMatchEventPrompt) {
                zipTools.promptUserForZip(zip.getDefault(), zipTools.redirectPath, true);
                AjaxComponent.misMatchEventPrompt = true;
              }
              return;
            }

            if (!data.containsOffers || data.offerBundle === null || data.offerBundle.offers.length === 0) {
              self.isLoading = false;
              $(self).trigger('ERROR');
              $(self).trigger('NO_ITEMS_FOUND');
              return;
            }
            self.parseData(data);
          })
          .catch(function (err) {
            console.error(err);
            self.isLoading = false;
            if (self.useModal) {
              $('#service-error-modal').modal('show');
            }
            $(self).trigger('ERROR');
          });
      } else {
      // todo: convert to use rest API
        $.ajaxSetup({
          async: true
        });
        $.ajax({
          dataType: 'json',
          url: self.serviceUrl,
          beforeSend: function (xhrObj) {
            xhrObj.setRequestHeader('Content-Type', 'application/json');
            xhrObj.setRequestHeader('Accept', 'application/json');
            xhrObj.overrideMimeType('application/json');
          }
        }).done(function (data) {
          // used to reside in parseData func directly
          // TODO: move to its own jam too, outta here
          if (data.containsErrors && data.totalOffers < 1 && data.error.length) {
            self.isLoading = false;
            // These events are triggered on each instance, on purpose!
            $(self).trigger('ERROR');
            $(self).trigger('NO_ITEMS_FOUND');
            for (var i = 0; i < data.error.length; i += 1) {
              var errorItem = data.error[i];
              if (errorItem === 'Mismatch zip and tda code entered.') {
                self.isTDAZipMisMatchError = true;
              }
            }

            // BAT25-329 In case of multiple offer calls, ensure we only prompt once
            // This should no longer be the case but until that can be tested...
            if (self.isTDAZipMisMatchError && !AjaxComponent.misMatchEventPrompt) {
              zipTools.promptUserForZip(zip.getDefault(), zipTools.redirectPath, true);
              AjaxComponent.misMatchEventPrompt = true;
            }
            return;
          }

          if (!data.containsOffers || data.offerBundle === null || data.offerBundle.offers.length === 0) {
            self.isLoading = false;
            $(self).trigger('ERROR');
            $(self).trigger('NO_ITEMS_FOUND');
            return;
          }
          self.parseData(data);
        }).fail(function (jqXHR, textStatus, errorThrown) {
          console.error(textStatus, errorThrown);
          self.isLoading = false;
          if (self.useModal) {
            $('#service-error-modal').modal('show');
          }
          $(self).trigger('ERROR');
        });

      }
    },

    // gets called by child classes AjaxOffers and AjaxInventory
    handlebarsData: function () {
      // console.log('-------------- END AJAX --------------');
      // console.log('MSRP debug: ', this.data);
      // console.log('in handlebarsData');
      var handlebarsHTML = Handlebars.hcompile(this.$template.html(), this.data);
      var $newItems = $(handlebarsHTML);

      this.currentTotal = this.data.numFound;

      // if coming from header-carousel-offers (or NON-ISOTOPE based offers call), just stop here and trigger complete?
      if (this.$isotopeContainer === false) {
        $(this).trigger('COMPLETE', [$newItems, this.data]);
        return;
      }

      // console.log('CURRENT TOTAL', this.currentTotal);
      if (this.currentTotal === 1) {
        $('.found').addClass('is-singular');
      } else {
        $('.found').removeClass('is-singular');
      }

      this.isLoading = false;

      // var timeoutDuration = 1500;  // BAT-3000 set timeout to fake loading animation

      if (this.isInitialLoad) {
        // console.log('initial load');
        // the initial load will have a slightly longer timeout
        // timeoutDuration = 3000;
        this.initialTotal = this.data.numFound;
        $(this).trigger('INITIAL_COMPLETE', [$newItems, this.data]);
        // need to move this further down
        // this.isInitialLoad = false;
      }

      $(this).trigger('COMPLETE', [$newItems, this.data]);
      $(window).trigger('OFFERS.COMPLETE', [$newItems, this.data]);

      // to ellipse the miscellaneous offer text on vehicle page
      // does this work!? Move to offers/offers.foo
      if ($('.layout-md').find('.description span').length) {
        $('.description span').each(function () {
          var description = $(this).text();
          if (description.length > 130) {
            var chopCharacter = description.substring(0, 120) + '...';
            $(this).text(chopCharacter);
          }
        });
      }
      if ($('.layout-md').find('.description').length) {
        $('.description').each(function () {
          var description = $(this).text();
          // console.log(description.length);
          if (description.length > 130) {
            var chopCharacter = description.substring(0, 120) + '...';
            $(this).text(chopCharacter);
          }
        });
      }
      // if offer title fond size is 12px
      if ($('.titles .model .textfitted').length) {
        $('.titles .model .textfitted').each(function () {
          var fontsize = $(this).css('font-size');
          if (fontsize == '12px') {
            $(this).css('font-size', '23px');
          }
        });
      }
      offersAnimations.animateOfferCards();
      this.isInitialLoad = false;
      window.bat.util.loader.hideLoader();// FOR BAT-3009
    }
  };

  return AjaxComponent;
});

